import { createContext, useContext } from "react";
import type { FC, ReactNode } from "react";

import { CAGlobals, USGlobals } from "@unauthenticated/shared/data/globals";

interface GlobalContextType {
  country: string;
  treatmentPlanTerm: string;
  emailRegex: RegExp;
}

const Default: GlobalContextType = {
  country: "United States",
  treatmentPlanTerm: "",
  emailRegex: new RegExp(""),
};

const GlobalContext = createContext<GlobalContextType>(Default);

const useGlobalConfig = () => {
  const { country, emailRegex, treatmentPlanTerm } = useContext(GlobalContext);

  const isCanada = country === CAGlobals.country;
  const isUS = country === USGlobals.country;

  return { country, isCanada, isUS, emailRegex, treatmentPlanTerm };
};

interface Props {
  country: string;
  treatmentPlanTerm: string;
  emailRegexString: string;
  children: ReactNode;
}

const GlobalContextProvider: FC<Props> = ({
  children,
  country,
  treatmentPlanTerm,
  emailRegexString,
}) => {
  const emailRegex = emailRegexString && new RegExp(emailRegexString);
  return (
    <GlobalContext.Provider value={{ country, treatmentPlanTerm, emailRegex }}>
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalContextProvider, useGlobalConfig };
export type { GlobalContextType };
